import { BRAND, DIVISION, SIGNATURE_QUOTE, TAGLINE } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F2018] border-t border-[#D4AF37]/15">
      <div className="mx-auto max-w-6xl px-5 py-14 text-center">
        <p className="font-script text-3xl text-[#D4AF37]">Shawnie &amp; Aunnie</p>
        <p data-testid="footer-brand" className="font-serif text-xl text-[#FBF9F1] mt-2">
          {BRAND}
        </p>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#D1DDD5]/60 mt-2">{TAGLINE}</p>
        <p className="mt-6 font-serif italic text-sm text-[#EED88F]/80">
          “{SIGNATURE_QUOTE}”
        </p>
        <div className="mt-8 pt-6 border-t border-[#D4AF37]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-[#D1DDD5]/50">
          <p data-testid="footer-division">{DIVISION}</p>
          <p>© {new Date().getFullYear()} {BRAND} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
